import Iphone18Promax from "pages/ProductDetail/Iphone18Promax";

export const iphoneFilterRoute = [
    {
        path: "/dien-thoai-iphone-18-pro-max-256gb-glacier",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
    {
        path: "/dien-thoai-iphone-18-pro-max-512gb-glacier",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
    {
        path: "/dien-thoai-iphone-18-pro-max-1tb-glacier",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
    {
        path: "/dien-thoai-iphone-18-pro-max-2tb-glacier",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },


    {
        path: "/dien-thoai-iphone-18-pro-max-256gb-burgundy",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
    {
        path: "/dien-thoai-iphone-18-pro-max-512gb-burgundy",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
    {
        path: "/dien-thoai-iphone-18-pro-max-1tb-burgundy",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
    {
        path: "/dien-thoai-iphone-18-pro-max-2tb-burgundy",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },


        {
        path: "/dien-thoai-iphone-18-pro-max-256gb-silver",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
    {
        path: "/dien-thoai-iphone-18-pro-max-512gb-silver",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
    {
        path: "/dien-thoai-iphone-18-pro-max-1tb-silver",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
    {
        path: "/dien-thoai-iphone-18-pro-max-2tb-silver",
        exact: true,
        name: "Trang chủ",
        component: Iphone18Promax,
    },
];
